import React from 'react';
import { Card } from '@material-ui/core';
import TaxAwareness from '../../TaxAwareness/TaxAwareness';
import { tRoweFormatted } from '../../../../utils/Content';

const TaxImplications = ({agreementsGroupByType, assetsAsOfDate}) =>
    <Card style={{ marginTop: '32px' }}>
        <div className='hub-header-container' id='pti-heading-container'>
            <h3
                className='hubSubHeader'
                style={{ paddingBottom: '16px', fontFamily: 'Nimbus Sans Reg' }}
                id='pti-heading'
            >
                Potential Tax Implications*
            </h3>
            <p
                style={{ fontFamily: 'Nimbus Sans Reg', fontSize: '16px', lineHeight: '24px' }}
                id='pti-copy'
            >
                When assets are sold, you could be subject to tax implications based on the amount of gains and/or losses.
                Unrealized gains or losses are estimated based on the cost basis information we have on file for you.
                As part of our tax-aware strategy, we may maintain funds selected for the Service, in part or in whole,
                within your Recommended Portfolio allocation, in an attempt to reduce the tax burden associated with the implementation
                of the Recommended Portfolio.  You should consult with a qualified legal or tax professional, such as a tax attorney or CPA,
                regarding your specific situation before making investment decisions.

            </p>
            <p
                style={{ fontFamily: 'Nimbus Sans Reg', fontSize: '16px', lineHeight: '24px' }}
                id='pti-copy-2'
            >
                Your current taxable (non-retirement) {tRoweFormatted} Mutual Fund accounts are listed below.
                Please note that these values represent the scenario in which all of these assets are sold.
                The chart does not include any unrealized gain/loss amounts for {tRoweFormatted} Brokerage account(s)
                or account(s) held away from {tRoweFormatted}. Unrealized gain/loss information for {tRoweFormatted} Brokerage account(s)
                can be found in Account Access using the login credentials of the owner of the {tRoweFormatted} Brokerage account(s).
                For account(s) held away from {tRoweFormatted}, please refer to information made available by the delivering firm.

            </p>
            <p
                className='hubPropAod'
                id='pti-as-of-date'
            >
                Proposal generated as of {assetsAsOfDate} and balances are generally as of the prior business day&apos;s close
            </p>
        </div>
        <div id='tax-awareness-container'>
            <TaxAwareness agreementsGroupByType={agreementsGroupByType} />
        </div>
    </Card>;

export default TaxImplications;
